import useResponsiveDesign from './useResponsiveDesign'
import { useIsPioneerStarterOrGrowth } from './useIsPioneerStarterOrGrowth'

export const useIsOnboardingRedesign = () => {
  const location = window.location // eslint-disable-line no-restricted-properties
  const { isMobile } = useResponsiveDesign()
  const isPioneer = useIsPioneerStarterOrGrowth() === 'pioneer'

  const isOnRegistration = location.pathname.includes('/signup')
  const isOnLogin = location.pathname.includes('/login')
  const isRegistrationOrLoginPath = isOnRegistration || isOnLogin

  return !isMobile && (!isPioneer || isRegistrationOrLoginPath)
}
